import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";

export default function MfaCodeForm({ onSubmit, onCancel, error, loading }) {
  const [code, setCode] = useState("");
  return (
    <form
      onSubmit={(e) => { e.preventDefault(); onSubmit(code); }}
      className="space-y-5"
      data-testid="mfa-code-form"
    >
      <div className="flex items-start gap-3 p-3 border border-ink-line bg-secondary/50 rounded-sm">
        <ShieldCheck className="w-5 h-5 text-brand shrink-0 mt-0.5" />
        <p className="text-sm text-ink-muted">Enter the 6-digit code from your authenticator app to finish signing in.</p>
      </div>
      <input
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
        inputMode="numeric"
        autoFocus
        placeholder="123456"
        data-testid="mfa-code-input"
        className="w-full px-3 py-2.5 border border-ink-line bg-white rounded-sm text-center font-num text-lg tracking-[0.5em] focus:outline-none focus:ring-2 focus:ring-brand/20 focus:border-brand"
      />
      {error && <div className="text-sm text-warn bg-warn-soft border border-warn/30 px-3 py-2 rounded-sm" data-testid="mfa-error">{error}</div>}
      <button type="submit" disabled={loading || code.length !== 6} data-testid="mfa-submit-btn" className="w-full bg-brand hover:bg-brand-hover disabled:opacity-60 text-white font-medium py-2.5 rounded-sm text-sm transition-colors">
        {loading ? "Verifying…" : "Verify & sign in"}
      </button>
      <button type="button" onClick={onCancel} data-testid="mfa-cancel-btn" className="w-full text-sm text-ink-muted hover:text-ink">Back to sign in</button>
    </form>
  );
}
